module.exports = __webpack_public_path__ + "static/media/0520-l.b6f301be.png";